import './NotFound.css';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
	const { t } = useTranslation();

	return (
		<div className='not-found'>
			<div className='not-found__code'>404</div>
			<div className='not-found__message'>{t('Page not found')}</div>
		</div>
	);
};

export { NotFound };
